
export const optimizationTargetOptions = {
  maximizeFinancialBenefits: "Maximize Financial Benefits",
  maximizeProduct: "Maximize Product",
  minimizeEnergyCost: "Minimize Energy Cost",
};
